


export default function GetUnixTimestampString():string {
  return (Math.floor(Date.now() / 1000)).toString();
}
